import { BackendEntry, VersionEntry } from './utils/environment-config';

export const ENVIRONMENT = {
    production: true,
};

export const BACKEND_URL: { [key: string]: BackendEntry } = {
    test: {
        backendURL: 'https://188.75.128.94:3004',
    },
    dev: {
        backendURL: 'http://localhost:3004',
    },
    prod: {
        backendURL: 'https://sync.jon.cz:3006',
    },
};

export const VERSION_URL: { [key: string]: VersionEntry } = {
    test: {
        versionURL: 'https://188.75.128.94/version.json',
    },
    dev: {
        versionURL: 'https://localhost/version.json',
    },
    prod: {
        versionURL: 'https://sync.jon.cz/version.json',
    },
};
